<template>
  <div>
    <b-card no-body>
      <!-- Head -->
      <table-header
        search
        search-placeholder="Cari berdasarkan nama"
        search-action="brand/getBrandList"
      >
        <template #action>
          <b-button
            v-if="canAccess('manage', 'Merchant')"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            :to="{ name: 'brands-create'}"
          >
            + Buat Brand
          </b-button>
        </template>
      </table-header>
      <!-- Body -->
      <b-skeleton-table
        v-if="isLoading"
        :rows="5"
        :columns="4"
      />
      <b-table
        v-else
        ref="refUserListTable"
        :items="brandList.data"
        responsive
        :fields="tableFields"
        primary-key="id"
        show-empty
        empty-text="Tidak ada data yang ditemukan"
        class="position-relative mh-160"
      >
        <!-- Column: Image -->
        <template #cell(image)="data">
          <b-media
            vertical-align="center"
          >
            <template #aside>
              <b-img
                rounded
                width="50"
                :src="linkStaging(data.item.image_url, 50, 50)"
                :alt="data.item.name"
                @error="(event) => {
                  event.target.src = require('@/assets/images/icons/broken-image.svg')
                }"
              />
            </template>
          </b-media>
        </template>

        <!-- Column: Name -->
        <template #cell(name)="data">
          {{ data.item.name }}
        </template>

        <!-- Column: Email -->
        <template #cell(email)="data">
          <a
            v-if="data.item.user.email"
            v-b-tooltip.hover.top="'Buka di Email'"
            target="_blank"
            :href="`mailto:${data.item.user.email}`"
          >{{ data.item.user.email }}</a>
          <span v-else>-</span>
        </template>

        <!-- Column: Phone -->
        <template #cell(phone)="data">
          <a
            v-if="data.item.user.phone"
            v-b-tooltip.hover.top="'Buka di WhatsApp'"
            target="_blank"
            :href="`https://wa.me/${data.item.user.phone}`"
          >+{{ data.item.user.phone }}</a>
          <span v-else>-</span>
        </template>

        <!-- Column: Actions -->
        <template
          v-if="canAccess('manage', 'Merchant')"
          #cell(actions)="data"
        >
          <div class="text-nowrap">
            <table-action
              :actions="tableAction"
              :data="data"
            />
          </div>
        </template>

      </b-table>
      <!-- Footer -->
      <div class="mx-2 mb-2">
        <pagination
          :data="brandList.meta"
          action="brand/getBrandList"
        />
      </div>
    </b-card>

    <b-modal
      v-if="canAccess('manage', 'Merchant')"
      id="modal-change-password"
      title="Ubah Password"
      hide-footer
      @hidden="dataToChangePassword = ''"
    >
      <brand-detail
        v-if="dataToChangePassword"
        :data="dataToChangePassword"
      />
      <PasswordForm
        v-if="dataToChangePassword"
        :data="dataToChangePassword"
        @finish="afterChangePassword"
      />
    </b-modal>

    <b-modal
      v-if="canAccess('manage', 'Merchant')"
      id="modal-reset-password"
      title="Reset Password"
      ok-title="Ya, Yakin"
      cancel-title="Batalkan"
      :ok-disabled="isSubmitting"
      @hidden="dataToResetPassword = ''"
      @ok.prevent="reset"
    >
      <brand-detail
        v-if="dataToResetPassword"
        :data="dataToResetPassword"
      />
      <span v-if="dataToResetPassword">Tautan untuk mengatur ulang password akan dikirim ke email brand. Apakah anda yakin?</span>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Ripple from 'vue-ripple-directive'
import {
  BSkeletonTable,
  BCard,
  BButton,
  BTable,
  BImg,
  BMedia,
  VBTooltip,
} from 'bootstrap-vue'

import PasswordForm from '@/layouts/components/form/PasswordForm.vue'
import Pagination from '@/layouts/components/custom/Pagination.vue'
import TableHeader from '@/layouts/components/custom/TableHeader.vue'
import TableAction from '@/layouts/components/custom/TableAction.vue'
import BrandDetail from './BrandDetail.vue'

export default {
  components: {
    BSkeletonTable,
    BCard,
    BButton,
    BTable,
    BImg,
    BMedia,

    PasswordForm,
    BrandDetail,
    Pagination,
    TableHeader,
    TableAction,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      tableFields: [
        { key: 'image', label: 'Image' },
        { key: 'name', label: 'Nama' },
        { key: 'email', label: 'Email' },
        { key: 'phone', label: 'Phone' },
        { key: 'actions', label: '' },
      ],
      isPending: false,
      isSubmitting: false,
      userDetail: {},
      dataToResetPassword: '',
      dataToChangePassword: '',
    }
  },
  computed: {
    ...mapState('brand', ['brandList', 'isLoading']),
    query() {
      return this.$route.query
    },
    tableAction() {
      return [
        {
          access: null,
          to: 'brands-edit|id:id',
          action: '',
          icon: 'EditIcon',
          title: 'Edit',
        },
        // {
        //   access: null,
        //   to: null,
        //   action: data => { this.showChangePassword(data) },
        //   icon: 'LockIcon',
        //   title: 'Ubah Password',
        // },
        {
          access: null,
          to: null,
          action: data => { this.showResetPassword(data) },
          icon: 'LockIcon',
          title: 'Reset Password',
        },
      ]
    },
  },
  async created() {
    await this.getBrandList(this.query)
  },
  methods: {
    ...mapActions('brand', ['getBrandList', 'resetPassword']),
    showDetailModal(item) {
      this.userDetail = item
      this.$bvModal.show('modal-user-detail')
    },
    async showChangePassword(data) {
      this.dataToChangePassword = await data
      this.$bvModal.show('modal-change-password')
    },
    async afterChangePassword() {
      this.$bvModal.hide('modal-change-password')
      this.dataToChangePassword = ''
    },
    async showResetPassword(data) {
      this.dataToResetPassword = await data
      this.$bvModal.show('modal-reset-password')
    },
    async afterResetPassword() {
      this.$bvModal.hide('modal-reset-password')
      this.dataToResetPassword = ''
    },
    async reset() {
      this.isSubmitting = true

      await this.resetPassword({ email: this.dataToResetPassword.email })
        .then(() => {
          this.afterResetPassword()
        })
        .finally(() => {
          this.isSubmitting = false
        })
    },
  },
}
</script>
